<template>
  <div>
    <div class="wearhouse-data-box">
      <el-input v-model="searchInfo" placeholder="请输入搜索" @input="searchInfoChange"></el-input>
      
      <div v-if="searchInfoLoading">
        <i class="el-icon-loading"></i> 正在搜索中...
      </div>
      <div class="product-wrap" v-else>
        <ul v-if="pageData.length">
          <li :title="item.namec" v-for="item in pageData[this.currentPage - 1]" :key="item.id" :class="{isActive: value && item.id === value.id}" @click="changePod(item)">{{ item.namec }}</li>
        </ul>
        <div v-else style="padding-bottom: 32px;text-align: center;">
          <img :src="ossPath + '/pages/home/no-data.png'" alt="">
          <p style="margin-top: 33px">抱歉，暂未找到相关数据</p>
        </div>

        <el-pagination
          align="right"
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :small="true"
          :total="total">
        </el-pagination>
        
      </div>
    </div>
  </div>
</template>

<script>
import {isArray, isObject, debounce} from "my-tools-kit";
export default {
  props: {
    baseData: Array,
    value: {}
  },
  data() {
    return {
      searchInfo: '',
      searchInfoFilerList: [],
      searchInfoLoading: false,
      filterData: [],
      pageData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  watch: {
    baseData: {
      immediate: true,
      handler(val) {
        this.searchInfoFilerList = val
        this.setPageData()
      }
    }
  },
  methods: {
    searchInfoChange(val) {
      this.changeSearch(val)
    },
    /**
     * 触发搜索
     */
     changeSearch:debounce(function(text = this.searchInfo){
      text = text.replace(/(^\s+)|(\s+$)/g,"");
      console.log(text);
      // text = text.toUpperCase();
      // let baseList = this.podData[this.podDefaultTabValue]
      let baseList = this.baseData
      let filterList = [];
      this.searchInfoLoading = true;
      filterList = this.searchList(text,baseList);
      this.searchInfoFilerList = filterList;
      this.setPageData()

    },200,false),
    /**
     * 搜索函数
     * @param text  {string}  搜索文本
     * @param baseList  {array} tabItem对应的list数据
     * @param tabItem {object}  tabHeadList列表的某项item
     * @returns {*[]}
     */
    searchList(text="",baseList=[]){
      let filterList = [];
      let hasCallback = typeof this.searchCallback === "function";
      let filterFunction = (text="",item)=>{
        // console.log("============",item[this.itemLabelKey])
        let itemLabel = String(item.namec||"");
        // let itemLabelE = String(item.name||"");
        let reg = RegExp(text,"ig");
        return reg.test(itemLabel)
      };
      filterList = baseList.filter(item=>{
        return hasCallback ? this.searchCallback(text,item) : filterFunction(text,item);
      });
      return filterList;
    },
    changePod(val) {
      this.$emit('change', val)
    },
    setPageData () {
      const pages = []
      let page = []
      this.searchInfoFilerList.forEach((item, index) => {
        page.push(item)
        if ((index + 1) % this.pageSize) {
          if ((index + 1) === this.searchInfoFilerList.length) pages.push(page)
        } else {
          pages.push(page)
          page = []
        }
      })
      this.searchInfoLoading = false
      this.pageData = pages
      this.total = this.searchInfoFilerList.length
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.setPageData()
    },
    sizeChange(val) {},
    currentChange(val) {}
  }
}
</script>

<style lang="scss" scoped>
.wearhouse-data-box {
    max-height: 300px;
    overflow-y: auto;
    /deep/ .el-input__inner {
      background: #F7F7F7;
      border: none
    }
    .product-wrap {
      padding: 10px 0;
      ul {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        text-align: center;
        li {
          margin-bottom: 6px;
          margin-right: 10px;
          padding: 3px 4px;
          width: calc(20% - 18px);
          color: #666;
          height: 30px;
          line-height: 30px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          border-radius: 5px;
          cursor: pointer;
          background: #f5f5f5;
          &.isActive {
            background-color: #FF4D01;
            color: white;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/privateOrder/components/searchWearhousePage.vue